//@ts-nocheck
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../redux/store";
import { userSliceSelectors } from "../redux/user/user.selector";

interface AtiraRouteProps {
  component: React.ReactNode;
  redirect?: string;
}

export const AtiraRouteNotLoggedIn: React.FC<AtiraRouteProps> = ({
  component,
  redirect,
}) => {
  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId);

  const isLoggedIn = Boolean(userId?.length);

  if (isLoggedIn) {
    return <Navigate to={redirect || "/home"} replace />;
  }

  return component;
};
